// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_UPDATE_CREDITS_COMPARE_FILTRADAS,
} from './constants';

export function updateCreditsCompareFiltradas(entidadOtorgante, nombreComercial, tipoTasa, dataSearch) {
  return {
    type: SIMULADOR_FINANCIERO_UPDATE_CREDITS_COMPARE_FILTRADAS,
    entidadOtorgante: entidadOtorgante,
    nombreComercial: nombreComercial,
    tipoTasa: tipoTasa,
    dataSearch: dataSearch
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_UPDATE_CREDITS_COMPARE_FILTRADAS:
      let comparadorDeLineas = {...state.comparadorDeLineas};
      let aux = [...state.comparadorDeLineas.lineas];

      if (action.entidadOtorgante !== null)  {
        if (action.entidadOtorgante.value !== 0) {
          aux = aux.filter(linea => linea.entidadFinanciera === action.entidadOtorgante.label);
        }
      }

      if (action.nombreComercial !== null) {
        if (action.nombreComercial.value !== 0) {
          aux = aux.filter(linea => linea.name === action.nombreComercial.label);
        }
      }

      if (action.tipoTasa !== null) {
        if (action.tipoTasa.value !== 0) {
          aux = aux.filter(linea => linea.tipoTasaDesc === action.tipoTasa.label);
        }
      }

      console.log("dataSearch", action.dataSearch);
      if (action.dataSearch !== '') {
        aux = aux.filter(linea => linea.entidadFinanciera.toLowerCase().includes(action.dataSearch.toLowerCase()) || linea.name.toLowerCase().includes(action.dataSearch.toLowerCase()));
      }

      comparadorDeLineas.lineasFiltradas = [...aux];
      comparadorDeLineas.lineasCreditoNombre = [];
      aux.forEach((item) => {
        comparadorDeLineas.lineasCreditoNombre.push(
          {
            label: item.name,
            value: item.id,
            id: 'lineaCreditoNombre'
          }
        )
      });
      return {
        ...state,
        comparadorDeLineas: comparadorDeLineas
      };

    default:
      return state;
  }
}
